import React from "react";
import { Modal, Button, Col, Row } from "antd";
import AButton from "./Button";
import { FailedIcon } from "../../../assets/icons/Failed";
import { typography } from "theme/Typography";
import { color } from "theme/Color";
import { SuccessTickIcon } from "../../../assets/icons/SuccessTick";

interface ConfirmationModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmationMessage: any;
  loading?: boolean;
  success?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ visible, onConfirm, onCancel, confirmationMessage, loading, success }) => {
  return (
    <Modal open={visible} onCancel={onCancel} width={380} closeIcon={null} footer={null} centered>
      <div className="modal-body">
        {success ? <SuccessTickIcon /> : <FailedIcon />}
        <p
          style={{
            fontSize: typography.fontSizes.lg,
            fontWeight: typography.fontWeights.semibold,
            lineHeight: "28px",
            color: color.TEXT_COLOR,
          }}
        >
          Confirmation
        </p>
        <p
          style={{
            fontSize: typography.fontSizes.sm,
            fontWeight: typography.fontWeights.normal,
            lineHeight: "20px",
            color: color.TEXT,
          }}
        >
          {confirmationMessage}
        </p>
      </div>
      <Row gutter={14} style={{ marginTop: "30px" }}>
        <Col span={12} style={{ display: "flex" }}>
          <AButton
            onClick={onCancel}
            style={{
              height: "40px",
              fontSize: "16px",
              fontWeight: "600",
              border: `1px solid ${color.DARK}`,
              flex: 1,
            }}
          >
            Cancel
          </AButton>
        </Col>
        <Col span={12} style={{ display: "flex" }}>
          <AButton
            type="primary"
            onClick={onConfirm}
            style={{
              height: "40px",
              fontSize: "16px",
              fontWeight: "600",
              flex: 1,
            }}
            loading={loading}
          >
            Confirm
          </AButton>
        </Col>
      </Row>
    </Modal>
  );
};

export default ConfirmationModal;
